import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="font-heading text-xl font-bold mb-4">韩国漫画网</h3>
            <p className="text-sm text-white/60 leading-relaxed">
              国内专业的韩国漫画在线阅读平台，每日同步更新海量好看韩国漫画。无删减下拉式免费阅读，为您呈现原汁原味的韩漫体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-white/90">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-white/60 hover:text-accent-300 transition-colors whitespace-nowrap">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-white/90">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-white/60 hover:text-accent-300 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/romance" className="text-sm text-white/60 hover:text-accent-300 transition-colors whitespace-nowrap">恋爱漫画</Link></li>
              <li><Link to="/category/action" className="text-sm text-white/60 hover:text-accent-300 transition-colors whitespace-nowrap">热血漫画</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-white/60 hover:text-accent-300 transition-colors whitespace-nowrap">奇幻漫画</Link></li>
              <li><Link to="/about" className="text-sm text-white/60 hover:text-accent-300 transition-colors whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-white/90">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-white/60">
                <i className="ri-mail-line text-accent-400 w-4 h-4 flex items-center justify-center"></i>
                <span>contact@koreanmanhwa.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-white/60">
                <i className="ri-wechat-line text-accent-400 w-4 h-4 flex items-center justify-center"></i>
                <span>KManhwa_Official</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-white/60">
                <i className="ri-weibo-line text-accent-400 w-4 h-4 flex items-center justify-center"></i>
                <span>@韩国漫画网官方</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/40">
            &copy; {new Date().getFullYear()} 韩国漫画网. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-white/40 hover:text-white/70 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-sm text-white/40 hover:text-white/70 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#" className="text-sm text-white/40 hover:text-white/70 transition-colors whitespace-nowrap">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}